module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hans/5-cbf4dd4c3c374a63d5609192430a600a.jpg";